import { Facebook, Instagram, Youtube, Linkedin, Phone, Mail, MapPin } from "lucide-react";
import { SITE, SERVICES, IMAGES } from "@/lib/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0B2545] text-white relative overflow-hidden grain">
      <div className="max-w-7xl mx-auto px-5 md:px-10 lg:px-12 py-16 md:py-20 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <img
            src={IMAGES.logo}
            alt="Vinodha Diagnostics — imaging at its best"
            className="h-14 w-auto"
            width="200"
            height="56"
          />
          <p className="mt-5 text-white/70 leading-relaxed max-w-md">
            A trusted diagnostic & imaging centre in South Bangalore, serving Hosa Road,
            Hebbagodi, Electronic City and neighbouring areas with NABL-aligned accuracy
            and expert radiologist reporting.
          </p>

          <div className="mt-6 flex gap-3">
            {[
              { href: SITE.social.facebook, icon: Facebook, label: "Facebook" },
              { href: SITE.social.instagram, icon: Instagram, label: "Instagram" },
              { href: SITE.social.youtube, icon: Youtube, label: "YouTube" },
              { href: SITE.social.linkedin, icon: Linkedin, label: "LinkedIn" },
            ].map(({ href, icon: Icon, label }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noreferrer"
                aria-label={label}
                data-testid={`social-${label.toLowerCase()}`}
                className="grid place-items-center w-10 h-10 rounded-full bg-white/5 border border-white/10 hover:bg-[#14B8A6] hover:border-[#14B8A6] transition-colors"
              >
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>

        <div className="lg:col-span-3">
          <div className="text-xs font-bold tracking-[0.22em] uppercase text-[#14B8A6]">Services</div>
          <ul className="mt-5 space-y-2.5">
            {SERVICES.map((s) => (
              <li key={s.slug}>
                <a href="#services" className="text-white/70 hover:text-white text-sm">
                  {s.name}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-4">
          <div className="text-xs font-bold tracking-[0.22em] uppercase text-[#14B8A6]">Reach us</div>
          <ul className="mt-5 space-y-4 text-sm">
            <li className="flex items-start gap-3 text-white/80">
              <Phone className="w-4 h-4 mt-0.5 text-[#14B8A6]" />
              <a href={`tel:${SITE.phoneRaw}`} className="hover:text-white">{SITE.phone}</a>
            </li>
            <li className="flex items-start gap-3 text-white/80">
              <Mail className="w-4 h-4 mt-0.5 text-[#14B8A6]" />
              <a href={`mailto:${SITE.email}`} className="hover:text-white">{SITE.email}</a>
            </li>
            {SITE.branches.map((b) => (
              <li key={b.name} className="flex items-start gap-3 text-white/80">
                <MapPin className="w-4 h-4 mt-0.5 text-[#14B8A6]" />
                <span>
                  <span className="font-semibold text-white">
                    {b.name} <span className="text-white/50 font-normal">· {b.label}</span>
                  </span>
                  <br />
                  <span className="text-white/60 text-xs">{b.address}</span>
                  <br />
                  <a href={`tel:${b.phoneRaw}`} className="text-[#14B8A6] text-xs hover:text-white">
                    {b.phones.join(" · ")}
                  </a>
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 md:px-10 lg:px-12 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <div>© {new Date().getFullYear()} Vinodha Diagnostics. All rights reserved.</div>
          <div className="flex gap-5">
            <a href="#" className="hover:text-white">Privacy</a>
            <a href="#" className="hover:text-white">Terms</a>
            <a href="#contact" className="hover:text-white">Contact</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
